var Vendd = (function (Vendd) {
    'use strict';

    Vendd.RequestOffer = (function (RequestOffer) {

        RequestOffer.Messages = (function (Messages) {

		//Request SuggestedResult Selected 	
        Messages.AddRequestForOfferItem = function (selectedItem) {             
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddRequestForOfferItem", selectedItem);
        };
        Messages.AddRequestForOfferItem.className = "Vendd.RequestOffer.Messages.AddRequestForOfferItem";

        Messages.SuggestedResultsSelected = function (selectedItem) {      
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SuggestedResultsSelected", selectedItem);
        };
        Messages.SuggestedResultsSelected.className = "Vendd.RequestOffer.Messages.SuggestedResultsSelected"; 
		
			
		//Request  RequestForOfferss Model Changed	
		
        Messages.ModelChanged = function (selectedItem) {
            var data = {
                selectedItem: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.ModelChanged", data);
        };
        Messages.ModelChanged.className = "Vendd.RequestOffer.Messages.ModelChanged"; 
		
			
		//Add Request ForOffer Item	
		
		Messages.AddRequestForOfferItemSuccess = function (response) {
            var data = {
                response: response
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddRequestForOfferItemSuccess", data);
        };
        Messages.AddRequestForOfferItemSuccess.className="Vendd.RequestOffer.Messages.AddRequestForOfferItemSuccess";

		Messages.AddRequestForOfferItemFailure = function (response) {
            var data = {
                response: response
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.AddRequestForOfferItem.Messages.AddRequestForOfferItemFailure", data);
        };
        Messages.AddRequestForOfferItemFailure.className = "Vendd.RequestOffer.Messages.AddRequestForOfferItemFailure";
		
						
		//Remove Request Offer Item	
		
        Messages.DeleteRequestForOfferItem = function (selectedItem) {
            var data = {
                identifier: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.DeleteRequestForOfferItem", data);
        };
        Messages.DeleteRequestForOfferItem.className = "Vendd.RequestOffer.Messages.DeleteRequestForOfferItem";
			
			
		  Messages.DeleteRequestForOfferItemSuccess = function (selectedItem) {
            var data = {
                selectedItem: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.DeleteRequestForOfferItemSuccess", data);
        };
        Messages.DeleteRequestForOfferItemSuccess.className = "Vendd.RequestOffer.Messages.DeleteRequestForOfferItemSuccess";
			
	   Messages.DeleteRequestForOfferItemFailure = function (selectedItem) {
            var data = {
                selectedItem: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.DeleteRequestForOfferItemFailure", data);
        };
        Messages.DeleteRequestForOfferItemFailure.className = "Vendd.RequestOffer.Messages.DeleteRequestForOfferItemFailure";			
		
		//Set Quantity
		{
		    Messages.SetQuantity = function ( requestForOfferItemId, quantity) {
            var data = {
                requestForOfferItemId: requestForOfferItemId,
                quantity: quantity
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SetQuantity", data);
        };
        Messages.SetQuantity.className = "Vendd.RequestOffer.Messages.SetQuantity";
			
			Messages.SetQuantitySuccess = function (selectedItem) {
            var data = {
                selectedItem: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SetQuantitySuccess", data);
        };
			Messages.SetQuantitySuccess.className = "Vendd.RequestOffer.Messages.SetQuantitySuccess";
			
			Messages.SetQuantityFailure = function (selectedItem) {
            var data = {
                selectedItem: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SetQuantityFailure", data);
        };
        Messages.SetQuantityFailure.className = "Vendd.RequestOffer.Messages.SetQuantityFailure";
			}

        //RequestOfferFileUpload
        {
            Messages.RequestForOfferFileUpload = function (filename, requestForOfferId) {
                var data = {
                    filename: filename,
                    requestForOfferId:requestForOfferId
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.RequestForOfferFileUpload", data);
            };
            Messages.RequestForOfferFileUpload.className = "Vendd.RequestOffer.Messages.RequestForOfferFileUpload";

            Messages.RequestForOfferFileUploadSuccess = function (selectedItem) {
                var data = {
                    selectedItem: selectedItem
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.RequestForOfferFileUploadSuccess", data);
            };
            Messages.RequestForOfferFileUploadSuccess.className = "Vendd.RequestOffer.Messages.RequestForOfferFileUploadSuccess";

            Messages.RequestForOfferFileUploadFailure = function (selectedItem) {
                var data = {
                    selectedItem: selectedItem
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.RequestForOfferFileUploadFailure", data);
            };
            Messages.RequestForOfferFileUploadFailure.className = "Vendd.RequestOffer.Messages.RequestForOfferFileUploadFailure";
        }

        //RequestOfferSubmit		
        Messages.RequestForOfferSubmit = function (requestOfferId) {
            var data = {
                requestOfferId: requestOfferId

            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.RequestForOfferSubmit", data);
        };
        Messages.RequestForOfferSubmit.className = "Vendd.RequestOffer.Messages.RequestForOfferSubmit";

        Messages.RequestForOfferSubmitSuccess = function (data) {

            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.RequestForOfferSubmitSuccess", data);
        };
        Messages.RequestForOfferSubmitSuccess.className = "Vendd.RequestOffer.Messages.RequestForOfferSubmitSuccess";

        Messages.RequestForOfferSubmitFailure = function (selectedItem) {
            var data = {
                selectedItem: selectedItem
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.RequestForOfferSubmitFailure", data);
        };
        Messages.RequestForOfferSubmitFailure.className = "Vendd.RequestOffer.Messages.RequestForOfferSubmitFailure";        


        Messages.SearchForProducts = function (searchTerm) {
            var data = {
                searchTerm: searchTerm
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SearchForProducts", data);
        };
        Messages.SearchForProducts.className = "Vendd.RequestOffer.Messages.SearchForProducts";

        Messages.SearchForProductsSuccess = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SearchForProductsSuccess", data);
        };
        Messages.SearchForProductsSuccess.className = "Vendd.RequestOffer.Messages.SearchForProductsSuccess";

        Messages.SearchForProductsFailed = function (response) {
            response.data = JSON.parse(response.data);
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SearchForProductsFailed", response);
        };
        Messages.SearchForProductsFailed.className = "Vendd.RequestOffer.Messages.SearchForProductsFailed";

        		
        Messages.AddOfferProducts = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddOfferProducts", data);
        };
        Messages.AddOfferProducts.className = "Vendd.RequestOffer.Messages.AddOfferProducts";

        Messages.AddOfferProductsSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddOfferProductsSuccess", data);
        };
        Messages.AddOfferProductsSuccess.className = "Vendd.RequestOffer.Messages.AddOfferProductsSuccess";

       Messages.AddOfferProductsFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddOfferProductsFailure", data);
        };
        Messages.AddOfferProductsFailure.className = "Vendd.RequestOffer.Messages.AddOfferProductsFailure";

        return Messages;

    })(RequestOffer.Messages || {});

        return RequestOffer;

    })(Vendd.RequestOffer || {});

return Vendd;

})(Vendd || {});